import container from "../../libs/container/container";

const amdHomeVideoModule = (function () {
    const name = 'home__video-module';

    const view = container.getBaseView(name);

    view.privateVars = {
        videoControls: false
    }

    view.startup = function () {

    };

    view.bind = function () {
        document.querySelector(view.publicVars.cssId.moduleHomeVideoSoundCls).addEventListener('click', function (e) {
            if(!view.privateVars.videoControls) {
                view.privateVars.videoControls = true;
                view.methods.handleSoundClick(e);
            }
        });
    };

    view.methods = {
        handleSoundClick: function (e) {
            document.querySelector(view.publicVars.cssId.moduleHomeVideoSoundCls).style.opacity = 0;

            document.querySelector(view.publicVars.cssId.moduleHomeVideoMainVideoElemCls).muted = false;
            document.querySelector(view.publicVars.cssId.moduleHomeVideoMainVideoElemCls).controls = true;
        }
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdHomeVideoModule;